export default __webpack_public_path__ + "static/media/boxicons.8d765747.woff2";